module.exports = __webpack_public_path__ + "img/342.22ba1a53.jpg";